export const WHO_WE_HELP_META_DESCRIPTION_BG =
  "Perceptica подкрепя PR, комуникационни, бранд и агенционни екипи с медиен мониторинг, медийно разузнаване и анализ на репутацията в ЮИЕ.";
